import React, {useContext} from "react";
import {motion} from "framer-motion";
import "./About.scss";
import {aboutSection} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import {fadeUp, staggerCards, cardItem, vp} from "../../utils/animations";

export default function About() {
  const {isDark} = useContext(StyleContext);
  if (!aboutSection.display) return null;

  return (
    <motion.section
      className={`about ${isDark ? "dark" : ""}`}
      id="about"
      initial="hidden"
      whileInView="show"
      viewport={vp}
      variants={fadeUp}
    >
      <div className="about__inner">
        <motion.span className="section-label" variants={fadeUp}>
          About
        </motion.span>

        <motion.div
          className="about__body"
          variants={staggerCards}
          initial="hidden"
          whileInView="show"
          viewport={vp}
        >
          {/* Main paragraphs */}
          {aboutSection.paragraphs.map((p, i) => (
            <motion.p key={i} className="about__para" variants={cardItem}>
              {p}
            </motion.p>
          ))}

          {/* Currently callout */}
          {aboutSection.currently && (
            <motion.div className="about__currently" variants={cardItem}>
              <span className="about__currently-label">Currently</span>
              <span className="about__currently-text">
                {aboutSection.currently}
              </span>
            </motion.div>
          )}

          {/* How I work — 3 principles */}
          {aboutSection.workingStyle &&
            aboutSection.workingStyle.length > 0 && (
              <motion.div
                className="about__principles-wrap"
                variants={cardItem}
              >
                <p className="about__principles-eyebrow">How I work</p>
                <ol
                  className="about__principles"
                  aria-label="Working principles"
                >
                  {aboutSection.workingStyle.map((item, i) => (
                    <li key={i} className="about__principle">
                      <span className="about__principle-num" aria-hidden="true">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <div className="about__principle-content">
                        <span className="about__principle-title">
                          {item.title}
                        </span>
                        <span className="about__principle-body">
                          {item.body}
                        </span>
                      </div>
                    </li>
                  ))}
                </ol>
              </motion.div>
            )}
        </motion.div>
      </div>
    </motion.section>
  );
}
